import React, { useState } from 'react';
import { LuEye } from 'react-icons/lu';
import SizeStockModal from './SizeStockModal';

// Sem gráfico de pizza aqui de propósito — só lista com barra de proporção.
// O ícone de olho abre o comparativo de estoque por tamanho (trazido de
// volta do antigo relatório "Estoque Total") com sugestão baseada nas
// vendas do período.
const SalesBySizeList = ({ data, stockBySize }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const sizes = data || [];
  const total = sizes.reduce((sum, s) => sum + s.quantity, 0);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h5 className="mb-0">Vendas por tamanho</h5>
        <button
          type="button"
          className="dashboard-eye-btn"
          onClick={() => setModalOpen(true)}
          aria-label="Ver estoque por tamanho"
        >
          <LuEye size={18} />
        </button>
      </div>

      {sizes.length === 0 ? (
        <p className="text-muted mb-0">Sem vendas nesse período.</p>
      ) : (
        <ul className="list-unstyled mb-0">
          {sizes.map((s) => {
            const pct = total > 0 ? (s.quantity / total) * 100 : 0;
            return (
              <li key={s.size} className="mb-2">
                <div className="d-flex justify-content-between" style={{ fontSize: 13 }}>
                  <span className="font-weight-bold">{s.size}</span>
                  <span className="text-muted">{s.quantity} ({pct.toFixed(1)}%)</span>
                </div>
                <div style={{ background: '#f1f5f9', borderRadius: 4, height: 6, overflow: 'hidden' }}>
                  <div style={{ width: `${pct}%`, background: '#7c3aed', height: '100%' }} />
                </div>
              </li>
            );
          })}
        </ul>
      )}

      <SizeStockModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        stockBySize={stockBySize}
        salesBySize={data}
      />
    </div>
  );
};

export default SalesBySizeList;
